import type { TLayout } from '../models/playlist'
import { AspectRatio } from '../database/custom-types/aspect-ratio'

/** Keep in sync with app `FrameLayoutService` single-section presets (1920×1080 / 1080×1080 / 1080×1920). */
export const SINGLE_SECTION_HORIZONTAL_LAYOUT: TLayout = {
  id: 'onesection',
  name: 'Full screen (landscape)',
  width: 1920,
  height: 1080,
  aspectRatio: AspectRatio.Horizontal,
  sections: { main: { x0: 0, y0: 0, width: 1920, height: 1080 } }
}

export const SINGLE_SECTION_VERTICAL_LAYOUT: TLayout = {
  id: 'onesection-vertical',
  name: 'Full screen (portrait)',
  width: 1080,
  height: 1920,
  aspectRatio: AspectRatio.Vertical,
  sections: { main: { x0: 0, y0: 0, width: 1080, height: 1920 } }
}

export const SINGLE_SECTION_SQUARE_LAYOUT: TLayout = {
  id: 'onesection-square',
  name: 'Full screen (square)',
  width: 1080,
  height: 1080,
  aspectRatio: AspectRatio.Square,
  sections: { main: { x0: 0, y0: 0, width: 1080, height: 1080 } }
}

/** Full-screen preset for portal CPS / feed frames matching the player’s portal aspect bucket. */
export function singleSectionLayoutForAspectRatio(aspectRatio: AspectRatio): TLayout {
  switch (aspectRatio) {
    case AspectRatio.Vertical:
      return SINGLE_SECTION_VERTICAL_LAYOUT
    case AspectRatio.Square:
      return SINGLE_SECTION_SQUARE_LAYOUT
    default:
      return SINGLE_SECTION_HORIZONTAL_LAYOUT
  }
}
